

// src/components/Features.jsx
import React from "react";
import "../styles/features.css";

const features = [
  {
    id: 1,
    title: "Practical Learning",
    description:
      "Hands-on Accounting, GST, MS Office, Tally & SAP with real-time business scenarios.",
    image: "/images/practicals.png",
  },
  {
    id: 2,
    title: "Placement Support",
    description:
      "Mock interviews, resume guidance and placement drives with expert trainers.",
    image: "/images/placement.png",
  },
  {
    id: 3,
    title: "Industry-Ready",
    description:
      "Transforming fresh commerce graduates into confident accounting professionals.",
    image: "/images/industry.png",
  },
];

export default function Features() {
  return (
    <section className="features-section" aria-label="Key Features">
      <div className="features-container">
        {features.map((feature) => (
          <article key={feature.id} className="feature-card">
            {/* TITLE BAR */}
            <div className="feature-header">
              <h3>{feature.title}</h3>
            </div>

            {/* IMAGE */}
            <div className="feature-image">
              <img src={feature.image} alt={feature.title} />
            </div>

            {/* CONTENT */}
            <div className="feature-body">
              <p>{feature.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
